import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getListaDetPanel = async (searchAofId,searchArtId,page, perPage) => {
    let queryParams = [];
    if (searchAofId) {
      queryParams.push(`lp_id=${encodeURIComponent(searchAofId)}`);
    } 
    if (searchArtId) {
      queryParams.push(`art_id=${encodeURIComponent(searchArtId)}`);
    }
       if (page) {
      queryParams.push(`page=${encodeURIComponent(page)}`);
    }
    if (perPage) {
      queryParams.push(`perPage=${encodeURIComponent(perPage)}`);
    }
    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
  
    return await getData("/artlistasprecios/busqueda_art_ofcab", queryString);
  }

export const getListaDetById = async (id) => {
    const res = await getData(`/artlistasprecios/${id}`)
    return res
}

export const postListaDet = async (body) => {
    const res = await postData('/artlistasprecios', body)
    return res
}

export const patchListaDet = async (id, body) => {
    const res = await patchData(`/artlistasprecios/${id}`, body)
    return res
}

export const deleteListaDet = async (id) => {
    const res = await deleteData(`/artlistasprecios/${id}`)
    return res
}

export const getArticulos = async () => {
    const res = await getData('/articulos');
    return res
}

export const getArticuloById = async (id) => {
    const res = await getData(`/articulos/${id}`)
    return res
}